
import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import mediaQueries from "../constants/mediaQueries";
import breakpoints from "../constants/breakpoints";

const pagelink = "/servicos/cnc-process";


const ImageContainer = styled.div`
  background: #363636;
  width: 100%;
  height: 80vh;
  background-image: url(${process.env.PUBLIC_URL + '/images/landing.jpg'});
  background-size:     cover;                     
  background-repeat:   no-repeat;
  background-position: center center;     
  /* background-blend-mode: multiply; */

  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;

  user-select: none;
  cursor: pointer;

  @media ${mediaQueries.extraSmallDevices} {
    justify-content: flex-start;
    background-color: rgba(200,150,150,0.8);
  }
  @media ${mediaQueries.smallDevices} {
    justify-content: flex-start;
    background-color: rgba(200,150,150,0.8);
  }
  @media ${mediaQueries.mediumDevices} {
    justify-content: flex-start;
    background-color: rgba(200,150,150,0.3);
  }
  @media ${mediaQueries.largeDevices} {
    justify-content: flex-start;
    background-color: rgba(200,150,150,0.3);
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    justify-content: flex-start;
    background-color: rgba(200,150,150,0.3);
  }
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  
  @media ${mediaQueries.extraSmallDevices} {
    width: 100%;
    padding: 15px;
    margin-left:0;
  }
  @media ${mediaQueries.smallDevices} {
    width: 100%;
    padding: 20px;
    margin-left:0;
  }
  @media ${mediaQueries.mediumDevices} {
    background-color: rgb(100,100,100);
    width: 60%;
    padding: 30px;
    margin-left:5vh;
  }
  @media ${mediaQueries.largeDevices} {
    background-color: rgb(100,100,100);
    width: 50%;
    padding: 50px;
    margin-left:100px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    background-color: rgb(100,100,100);
    width: 50%;
    padding: 50px;
    margin-left:100px;
  }
`;

const Logline = styled.div`
  font-family: "SUSE", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  color: white;
  font-size: 40px;

  @media ${mediaQueries.extraSmallDevices} {
    font-size: 30px;
  }
  @media ${mediaQueries.smallDevices} {
    font-size: 30px;
  }
  @media ${mediaQueries.mediumDevices} {
    font-size: 32px;
  }
  @media ${mediaQueries.largeDevices} {
    font-size: 40px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 40px;
  }

`;

const Description = styled.div`
  font-family: "Kanit", sans-serif;
  font-weight: 200;
  font-style: normal;
  font-size: 20px;
  color: white;
  margin-top: 30px;

  @media ${mediaQueries.extraSmallDevices} {
    font-size: 15px;
  }
  @media ${mediaQueries.smallDevices} {
    font-size: 15px;
  }
  @media ${mediaQueries.mediumDevices} {
    font-size: 17px;
  }
  @media ${mediaQueries.largeDevices} {
    font-size: 20px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 20px;
  }
`;

const OurServices = styled.div`
  font-family: "Kanit", sans-serif;
  font-weight: 200;
  font-style: normal;
  background-color: grey;
  color: white;
  margin-top: 30px;
  border-radius: 5px;
  padding: 10px;
  &:hover{
    background-color: orange;
    text-decoration: none;
    color: white;
  }

  @media ${mediaQueries.extraSmallDevices} {
    font-size: 15px;
  }
  @media ${mediaQueries.smallDevices} {
    font-size: 15px;
  }
  @media ${mediaQueries.mediumDevices} {
    font-size: 17px;
  }
  @media ${mediaQueries.largeDevices} {
    font-size: 20px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 20px;
  }
`;


class PromptBlock extends React.Component {
  componentDidMount() {}
  render(){
    return(
      <ImageContainer>
        <TextBlock>
          <Logline>Maquinação de <a style={{backgroundColor: 'rgb(2,161,75)'}}>Madeiras, Derivados e Plásticos</a></Logline>
          <Description>Fabrique peças para mobiliário, revestimentos, produtos de decoração e arte</Description>
          <OurServices as={Link} to={pagelink}>VER PROCESSO</OurServices>
        </TextBlock>
      </ImageContainer>
    );
    ;

  }
}


export default PromptBlock;